module.exports = __webpack_public_path__ + "bb613f4716450ddf91e2e5bcd0a37b1e.svg";